import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { addBankDetail, getAllBankDetailByUserId } from '../../../../../app/store/slices/bank/bank';

export default function useAddBankDetail() {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const [loading, setLoading] = useState(false);

    const initialValues = {
        bankName: '',
        accountHolderName: '',
        accountNumber: '',
        confirmAccountNumber: '',
        ifscCode: '',
        accountType: null,
        nickName: '',
        isTermsAccepted: false
    };

    const validationSchema = Yup.object({
        bankName: Yup.string().required('Bank Name is required'),
        accountHolderName: Yup.string().required('Account Holder Name is required'),
        accountNumber: Yup.string().required('Account Number is required'),
        confirmAccountNumber: Yup.string()
            .oneOf([Yup.ref('accountNumber'), null], 'Account numbers must match')
            .required('Confirm Account Number is required'),
        ifscCode: Yup.string().required('IFSC Code is required'),
        accountType: Yup.object().required('Account Type is required'),
        nickName: Yup.string().required('Nick Name is required'),
        isTermsAccepted: Yup.boolean().oneOf([true], 'You must accept the terms and conditions')
    });

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values) => {
            try {
                setLoading(true);

                const payload = {
                    user_id: user?.id,
                    bank_name: values.bankName,
                    account_holder_name: values.accountHolderName,
                    account_number: values.accountNumber,
                    ifsc_code: values.ifscCode,
                    account_type: values.accountType?.value,
                    is_primary: false,
                    nickname: values.nickName,
                    tnc_approved: values.isTermsAccepted
                };

                await dispatch(addBankDetail(payload)).unwrap();
                await dispatch(getAllBankDetailByUserId({ user_id: user?.id })).unwrap();
                setLoading(false);
                formik.resetForm();
            } catch (error) {
                // console.error("Error updating bank details:", error)
                // Check for nickname uniqueness error
                if (
                    error?.status_code === 422 &&
                    (error?.message?.includes('Nickname already exists') ||
                        error?.error?.some((err) => err.includes('nickname must be unique')))
                ) {
                    formik.setFieldError(
                        'nickName',
                        'This nickname already exists. Please use a different one.'
                    );
                }
                setLoading(false);
            }
        }
    });
    return {
        accountTypes,
        formik,
        loading
    };
}

const accountTypes = [
    { label: 'Savings', value: 'savings' },
    { label: 'Current', value: 'current' }
];

// {
//   "status": false,
//   "message": "Nickname already exists for this user.",
//   "error": [
//     "The nickname must be unique for this user."
//   ],
//   "status_code": 422
// }
